export class FolderListDeletedEvent {
	public constructor(public folderId: string) {}
}
